<template>
    <transition name="fade">
        <div>
            <div class="row justify-content-center">
                <div class="col-lg-10 col-md-12 col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title bold">Preview of Application</h3>
                        </div>

                        <div class="card-body">
                            <div class="alert alert-info2 text-justify">
                                <i class="fas fa-info-circle mr-1 fs-15"></i> <b>Note:</b>Please review all the information you have entered for your loan application to make sure that everything is accurate and in order. Should you wish to edit anything, you may click the "Back" button and input the correct information.
                            </div>
                            <div class="details">
                                <div class=" details-title d-flex justify-content-between p-1">
                                    <h4>Borrower Information</h4>
                                </div>
                                <div class="details-body">
                                    <div class="row">
                                        <div class="col-sm-6 ">First Name:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0"> <span class="text-uppercase">{{user.fname}}</span> </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Middle Name:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0"> <span v-show="user.mname && user.mname !='NMN'" class="text-uppercase">{{user.mname}}</span> <span v-show="!user.mname || user.mname =='NMN'">-</span></label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Last Name:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0 "> <span class="text-uppercase">{{user.lname}}</span></label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Suffix:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0">
                                                <span v-if="user.suffix_code=='2020001'">I</span>
                                                <span v-else-if="user.suffix_code=='2020002'">II</span>
                                                <span v-else-if="user.suffix_code=='2020003'">III</span>
                                                <span v-else-if="user.suffix_code=='2020004'">SR.</span>
                                                <span v-else-if="user.suffix_code=='2020005'">JR.</span>
                                                <span v-else>-</span>
                                            </label>

                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Birth Date:<span class="note">(MM/DD/YYYY)</span></div>
                                        <div class="col-sm-6">
                                            <label class="mb-0 "> {{user.date_birth | MM/DD/YYYY}}</label>
                                        </div>
                                    </div>

                                </div>
                            </div>


                            <div class="details">
                                <div class="details-title d-flex justify-content-between p-1">
                                    <h4>Business Details</h4>
                                </div>
                                <div class="details-body">
                                    <div class="row">
                                        <div class="col-sm-6 ">Type of Business:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0 ">
                                                <span v-if="formLoan.bt_code=='BT2020002'">Partnership</span>
                                                <span v-if="formLoan.bt_code=='BT2020001'">Sole Proprietorship</span>
                                                <span v-if="formLoan.bt_code=='BT2020003'">Cooperative</span>
                                                <span v-if="formLoan.bt_code=='BT2020004'">Corporation</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">
                                            <span v-if="formLoan.bt_code=='BT2020002'">Partnership Name:</span>
                                            <span v-else-if="formLoan.bt_code=='BT2020004'">Corporation Name:</span>
                                            <span v-else>Business Name:</span>
                                        </div>
                                        <div class="col-sm-6">
                                            <label class="mb-0 ">
                                                <span class="text-uppercase">{{formLoan.business_name}} </span>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6 ">
                                            <span v-if="formLoan.bt_code=='BT2020002'">Partnership Date:</span>
                                            <span v-else-if="formLoan.bt_code=='BT2020004'">Incorporation Date:</span>
                                            <span v-else>Startup Date:</span>
                                            <span class="note">(MM/DD/YYYY)</span>
                                        </div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0 "> {{formLoan.start_date | MM/DD/YYYY}} </label>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12 mt-2 sub-title"><b>Business Address</b></div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6 ">Province:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0  "> {{formLoan.province}} </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">City:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0 "> {{formLoan.city}}</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Barangay:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0 "> {{formLoan.bname}}</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Street Name / Subdivision:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0"> {{formLoan.street_address}} </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">House No/Block & Lot/Building:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0"> {{formLoan.bldg}} </label>
                                        </div>
                                    </div>
                                    <!-- <div class="row">
                                        <div class="col-sm-12 mt-2 sub-title"><b>No. of paid employees as of prior year</b></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Regular Employees:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0  "> {{formLoan.prev_reg_emp}} </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Contractual Employees:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0 "> {{formLoan.prev_contract_emp}} </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12 mt-2 sub-title"><b>No. of paid employees at time of loan</b></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Regular Employees:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0 "> {{formLoan.current_reg}}</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Contractual Employees:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0 "> {{formLoan.current_contract}} <span class="empty" v-show="formLoan.current_contract==''">(click here)</span></label>
                                        </div>
                                    </div> -->
                                </div>
                            </div>

                            <div class="details">
                                <div class=" details-title d-flex justify-content-between p-1">
                                    <h4>Asset Size and Annual Sales</h4>
                                </div>
                                <div class="details-body">
                                    <div class="row">
                                        <div class="col-sm-6 ">Estimated Asset Size:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0 ">
                                                <span v-show="formLoan.asset_size"> {{ formLoan.asset_size | currency}} </span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Estimated Annual Sales:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0  ">
                                                <span>{{ formLoan.annual_sale | currency}} </span>
                                            </label>
                                        </div>
                                    </div>
                                    <!-- <div class="row">
                                        <div class="col-sm-6 ">Tin:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0"> {{formLoan.tin}}</label>
                                        </div>
                                    </div> -->
                                </div>
                            </div>

                            <div class="details">
                                <div class="details-title d-flex justify-content-between p-1">
                                    <h4>Application Details</h4>
                                </div>
                                <div class="details-body">



                                    <div class="row">
                                        <div class="col-sm-6 ">Loan Amount:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0"> {{ formLoan.req_loan_amt | currency}} </label>

                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Loan Term <span class="note">(in months):</span></div>
                                        <div class="col-sm-6">
                                            <label class="mb-0"> {{formLoan.req_loan_term}} </label>

                                        </div>
                                    </div>




                                    <div class="row">
                                        <div class="col-sm-12 mt-2 sub-title"><b>How do you want to receive your loan proceeds?</b></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Manner of Release:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0 "> {{formLoan.manner_rel_desc}} </label>

                                        </div>
                                    </div>

                                    <div class="row" v-if="formLoan.manner_rel !='GC' && formLoan.manner_rel !='PM'">
                                        <div class="col-sm-6 ">Bank Name:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0 "> {{formLoan.bankname}}</label>

                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Account Name:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0 ">
                                                <span class="text-uppercase">{{formLoan.acctname}} </span>
                                            </label>
                                        </div>

                                    </div>
                                    <div class="row" v-if="formLoan.manner_rel !='GC' && formLoan.manner_rel !='PM'">
                                        <div class="col-sm-6 ">Account Number:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0"> {{formLoan.acctno }} </label>
                                        </div>
                                    </div>

                                    <div class="row" v-if="formLoan.manner_rel =='GC' || formLoan.manner_rel =='PM'">
                                        <div class="col-sm-6 ">Registered Mobile Number:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0"> {{formLoan.acctno }} </label>
                                        </div>
                                    </div>

                                    <div class="row" v-if="formLoan.loan_bus_code!='FIB05'">
                                        <div class="col-sm-12 mt-2">* Your Service Fee is <strong>{{formLoan.service_fee}}</strong></div>
                                        <div class="col-sm-12 ">* Payment Mode is <strong>Monthly</strong></div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="card-footer">
                            <button class="btn btn-primary" @click="btnBack()"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                            <button class="btn btn-primary float-right" @click="btnNext()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </transition>
</template>
<script>
    export default {
        props: ['formLoan', 'user'],
        components: {},
        data() {

            return {}
        },

        created() {

        },
        methods: {
            btnBack() {
                this.$parent.updateStep(4, 'S4Q1');
            },
            btnNext() {
                this.$parent.updateStep(5, 'S5Q1');
            },

        },
        computed: {},
        mounted() {}
    }
</script>



<style scoped>
    /* Added for Preview Details */
    .details>.details-title {
        background-color: #f1f5fb;
        margin-bottom: 0px;
    }

    .details>.details-title h4 {
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
        margin-bottom: 0px;
    }

    .details>.details-title .btn-sm {
        padding: 1px 4px;
    }

    .details>.details-body .sub-title {
        font-size: 15px;
        /* color: #908fa2; */
        text-decoration: underline;
    }

    .details>.details-body {
        padding: 0px 10px 10px;
        font-size: 15px;
    }

    .note {
        font-size: 12px;
        color: #6c757d;
    }

    .details>.details-body .btn-group-sm>.btn,
    .details>.details-body .btn-sm {
        padding: 0px 8px;
        font-size: 13px;
    }

    .details>.details-body,
    .details>.details-body label {
        font-size: 15px;
        font-weight: 400;
    }


    @media(max-width:576px) {

        .details>.details-body,
        .details>.details-body label {
            font-size: 15px;
            font-weight: 600;
        }

        .details>.details-body .sub-title {
            font-size: 17px;
        }
    }

    .details>.details-body .form-control-sm,
    .details>.details-body .custom-select-sm {
        height: 1.5rem;
    }

    .details-body .custom-select-sm {
        font-size: 14px !important;
        padding-top: 0.04rem;
        padding-bottom: 0.1rem;
    }
</style>